import { IconDiscount } from '@redteclab/icons'
import { type FC } from 'react'

import SvgIcon, { type IconProps } from './SvgIcon'

const IconCirclePercent: FC<IconProps> = props => (
  <SvgIcon {...props} component={IconDiscount} />
)

export default IconCirclePercent
